<template>
  <v-dialog v-model="dialogModel" max-width="600" @keydown.esc="$emit('update:dialog', false)">
    <v-card v-if="incidencia">
   
      <v-card-title class="headline">
        <span>Incidencia #{{ incidencia.id }}</span>
      </v-card-title>


      <v-card-text class="pa-4">
        <v-row>
          <v-col cols="12" md="6">
            <span class="font-weight-bold text-caption d-block">Tipo</span>
            <span class="status-badge">{{ incidencia.code.name }}</span>
          </v-col>
          <v-col cols="12" md="6">
            <span class="font-weight-bold text-caption d-block">Fecha</span>
            <span>{{ incidencia.creation_date }}</span>
          </v-col>
          <v-col cols="12" md="6">
            <span class="font-weight-bold text-caption d-block">Reportado por</span>
            <span>{{ incidencia.user_reported ? incidencia.user_reported.name : '-' }}</span>
          </v-col>
          <v-col cols="12" md="6" v-if="incidencia.shipment_order_item">
            <span class="font-weight-bold text-caption d-block">Pedido</span>
            <span>{{ incidencia.shipment_order_item.shipment_order.code }}</span>
          </v-col>
   
          <v-col cols="12" v-if="incidencia.reason_text">
            <span class="font-weight-bold text-caption d-block">Motivo</span>
            <span>{{ incidencia.reason_text }}</span>
          </v-col>
        </v-row>

        <v-divider class="my-3"></v-divider>

        <v-row>
            <v-col cols="12" md="6" v-if="incidencia.shipment_order_item && incidencia.shipment_order_item.product">
            <span class="font-weight-bold text-caption d-block">Producto</span>
            <div class="font-weight-bold">{{ incidencia.shipment_order_item.product.name || '-' }}</div>
            <div class="text-caption text-grey-600">SKU: {{ incidencia.shipment_order_item.product.sku || '-' }}</div>
          </v-col>
        <v-col cols="12" md="6" v-if="incidencia.qty_found != null && incidencia.qty_found !== ''">
            <span class="font-weight-bold text-caption d-block">{{ getQtyLabel(incidencia.code) }}</span>

            <div class="text-caption mt-1">{{ incidencia.qty_found }}</div>

          </v-col>
          <v-col cols="12" md="6" v-if="incidencia.lpn_code">
            <span class="font-weight-bold text-caption d-block">LPN</span>
            <div class="text-caption mt-1">{{ incidencia.lpn_code }}</div>
          </v-col>
          <v-col cols="12" md="6" v-if="incidencia.ubicacion_code">
            <span class="font-weight-bold text-caption d-block">Ubicación</span>
            <div class="text-caption mt-1">{{ incidencia.ubicacion_code }}</div>
          </v-col>
        </v-row>

        <template v-if="incidencia.photos && incidencia.photos.length">
          <v-divider class="my-3"></v-divider>
          <p class="font-weight-bold text-caption mb-2">Fotos</p>
          <v-row>
            <v-col
              v-for="(photo, i) in incidencia.photos"
              :key="i"
              cols="6"
              md="4"
            >
              <v-img
                :src="photo.photo_url"
                aspect-ratio="1"
                cover
                class="rounded"
                @click="openFullPhoto(photo.photo_url)"
                style="cursor: pointer"
              ></v-img>
            </v-col>
          </v-row>
        </template>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="error" text @click="closeModal()">Cerrar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    dialog: { type: Boolean, required: true },
    incidencia: { type: Object, default: null },
  },
  emits: ["update:dialog"],
  computed: {
    dialogModel: {
      get() {
        return this.dialog;
      },
      set(value) {
        this.$emit("update:dialog", value);
      },
    },
  },
  methods: {
    getQtyLabel(code) {
      switch (code && code.id) {
        case "PRODUCT_DAMAGED":
          return "Cantidad dañado";
        case "PRODUCT_MISSING":
          return "Cantidad faltante";
        case "FORCED_CLOSE":
          return "Cantidad no pickeada";
        default:
          return "Cantidad";
      }
    },
    openFullPhoto(url) {
      window.open(url, "_blank");
    },
    closeModal(){
      this.$emit('update:dialog', false);
    }
  },
};
</script>
